const TRADING_TIPS = [
    {
        category: 'Risk Management',
        title: 'Size positions before picking direction',
        analysis: 'Most drawdowns come from oversized entries, not bad signals. Cap each bot at 1–2% of portfolio risk and scale only after a full week of stable logs.',
        symbol: 'BTCUSDT',
        sentiment: 'neutral',
    },
    {
        category: 'Grid Strategy',
        title: 'Grids love ranges, not breakouts',
        analysis: 'Grid bots earn in sideways markets. Set upper and lower bounds inside recent support/resistance — if price trends hard one way, pause the grid and reassess.',
        symbol: 'ETHUSDT',
        sentiment: 'neutral',
    },
    {
        category: 'Market Structure',
        title: 'Volume confirms the move',
        analysis: 'A breakout without rising volume often fades. Pair price conditions with volume indexes in your algo bot before enabling aggressive entries.',
        symbol: 'BTCUSDT',
        sentiment: 'bullish',
    },
    {
        category: 'Scheduled Trading',
        title: 'DCA works best on a schedule',
        analysis: 'Time-based entries remove timing stress. Use a scheduled bot for fixed weekly buys and keep quantity small enough to survive volatility clusters.',
        symbol: 'BTCUSDT',
        sentiment: 'bullish',
    },
    {
        category: 'Futures',
        title: 'Leverage amplifies mistakes too',
        analysis: 'High leverage turns small adverse moves into liquidations. Start at low leverage, enable reduce-only on exits, and never size futures like spot.',
        symbol: 'BTCUSDT',
        sentiment: 'bearish',
    },
    {
        category: 'Indicators',
        title: 'RSI extremes need context',
        analysis: 'Oversold RSI in a strong downtrend can stay oversold for days. Combine RSI with trend filters — e.g. only buy when price is above a longer moving average.',
        symbol: 'ETHUSDT',
        sentiment: 'neutral',
    },
    {
        category: 'Bot Ops',
        title: 'Enable logs during rollout',
        analysis: 'First 48 hours on a new bot should run with logging on. You will catch misconfigured quantities, wrong symbols, and condition typos faster.',
        symbol: null,
        sentiment: 'neutral',
    },
    {
        category: 'Liquidity',
        title: 'Stick to liquid pairs',
        analysis: 'Thin order books widen slippage on market orders. Major pairs (BTC, ETH, BNB) execute more predictably for grid and scheduled strategies.',
        symbol: 'BTCUSDT',
        sentiment: 'neutral',
    },
    {
        category: 'Backtesting',
        title: 'Backtest before going live',
        analysis: 'A strategy that looks good visually may fail on fees and min notional. Run monthly backtests within your plan limit before activating automations.',
        symbol: null,
        sentiment: 'neutral',
    },
    {
        category: 'Volatility',
        title: 'Widen grids when ATR rises',
        analysis: 'When average true range expands, tight grid spacing gets run over. Increase level spacing or shrink position size until volatility settles.',
        symbol: 'ETHUSDT',
        sentiment: 'bearish',
    },
    {
        category: 'Spot vs Futures',
        title: 'Match bot type to market',
        analysis: 'Spot grids avoid funding and liquidation risk. Use futures only when you need hedging or short exposure and understand margin rules.',
        symbol: null,
        sentiment: 'neutral',
    },
    {
        category: 'Order Types',
        title: 'Limits control cost, markets control speed',
        analysis: 'Use limit orders in ranges for better fills. Reserve market orders for scheduled bots where execution certainty matters more than price.',
        symbol: 'BTCUSDT',
        sentiment: 'neutral',
    },
    {
        category: 'Psychology',
        title: 'Let the bot hold the line',
        analysis: 'Manual overrides during volatility usually hurt performance. Define rules upfront — if you change them daily, automation cannot work.',
        symbol: null,
        sentiment: 'neutral',
    },
    {
        category: 'Monitors',
        title: 'Monitors are your early warning',
        analysis: 'Price and wallet monitors feed your conditions. Review active monitors weekly; stale indexes are a common reason automations stop firing.',
        symbol: null,
        sentiment: 'neutral',
    },
    {
        category: 'Trend Following',
        title: 'Trend bots need exit rules',
        analysis: 'Entries on breakouts are only half a strategy. Always pair buy automations with take-profit or trailing sell templates.',
        symbol: 'SOLUSDT',
        sentiment: 'bullish',
    },
    {
        category: 'Risk Management',
        title: 'One symbol, one thesis',
        analysis: 'Running unrelated strategies on the same pair increases correlation risk. Align grid bounds and algo conditions with a single market view.',
        symbol: 'BTCUSDT',
        sentiment: 'neutral',
    },
    {
        category: 'API Security',
        title: 'Trade-only API keys',
        analysis: 'Never enable withdrawals on exchange API keys. Use IP restrictions where supported and rotate keys if you change deployments.',
        symbol: null,
        sentiment: 'neutral',
    },
    {
        category: 'Macro',
        title: 'Respect event risk',
        analysis: 'Fed announcements and CPI releases spike volatility. Consider pausing tight grids or reducing size around high-impact macro dates.',
        symbol: 'BTCUSDT',
        sentiment: 'bearish',
    },
    {
        category: 'Algo Bot',
        title: 'Keep conditions readable',
        analysis: 'Complex nested conditions are hard to debug. Build buy and sell automations separately with clear names and test each side independently.',
        symbol: 'ETHUSDT',
        sentiment: 'neutral',
    },
    {
        category: 'Portfolio',
        title: 'Diversify bot strategies',
        analysis: 'Combine a range grid on one pair with scheduled DCA on another. Strategy diversification smooths equity curves better than pair chasing.',
        symbol: null,
        sentiment: 'bullish',
    },
    {
        category: 'Fees',
        title: 'Fees eat grid profits',
        analysis: 'High-frequency grid levels pay more maker/taker fees. Model fee drag when choosing level count — fewer levels can mean higher net returns.',
        symbol: 'BTCUSDT',
        sentiment: 'neutral',
    },
    {
        category: 'Support & Resistance',
        title: 'Anchor grids to structure',
        analysis: 'Place lower bounds near proven support and upper bounds below heavy resistance. Random ranges invite one-sided inventory buildup.',
        symbol: 'ETHUSDT',
        sentiment: 'neutral',
    },
    {
        category: 'Execution',
        title: 'Min notional matters',
        analysis: 'Exchanges reject orders below minimum notional. Use Min. Notional in grid setup or verify quantity × price before saving templates.',
        symbol: null,
        sentiment: 'neutral',
    },
    {
        category: 'Bear Markets',
        title: 'Reduce size in downtrends',
        analysis: 'Falling markets punish aggressive DCA and wide long grids. Cut order size by 30–50% until higher-timeframe trend stabilizes.',
        symbol: 'BTCUSDT',
        sentiment: 'bearish',
    },
    {
        category: 'Bull Markets',
        title: 'Take profits systematically',
        analysis: 'Rallies tempt manual greed. Predefine sell automations or grid upper levels so profits lock in without constant chart watching.',
        symbol: 'ETHUSDT',
        sentiment: 'bullish',
    },
    {
        category: 'Monitoring',
        title: 'Check wallet drift daily',
        analysis: 'Grid bots shift your base/quote balance over time. Rebalance or adjust bounds if inventory skews too far from your target allocation.',
        symbol: null,
        sentiment: 'neutral',
    },
    {
        category: 'Education',
        title: 'Paper discipline beats hot tips',
        analysis: 'Consistent process outlasts single trade ideas. Review Learn guides when adding a new bot type instead of copying random social signals.',
        symbol: null,
        sentiment: 'neutral',
    },
    {
        category: 'Correlation',
        title: 'Alts follow BTC beta',
        analysis: 'Many alt pairs amplify BTC moves. When BTC volatility spikes, widen alt grid ranges or reduce concurrent alt bot count.',
        symbol: 'BTCUSDT',
        sentiment: 'bearish',
    },
    {
        category: 'Session Trading',
        title: 'Liquidity varies by session',
        analysis: 'US and EU overlap hours typically have tighter spreads. Schedule larger market orders during liquid windows when possible.',
        symbol: 'ETHUSDT',
        sentiment: 'neutral',
    },
    {
        category: 'Stop Logic',
        title: 'Define max pain upfront',
        analysis: 'Set max open positions and wallet allocation caps before activation. Hard limits prevent one bad week from dominating your portfolio.',
        symbol: null,
        sentiment: 'bearish',
    },
    {
        category: 'Review',
        title: 'Weekly bot health check',
        analysis: 'Spend 15 minutes each weekend reviewing active bots: fill rate, error logs, and PnL vs benchmark hold. Small tweaks beat full rebuilds.',
        symbol: null,
        sentiment: 'neutral',
    },
];

function getDateKey(date = new Date()) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

function hashString(value) {
    let hash = 0;
    for (let i = 0; i < value.length; i += 1) {
        hash = ((hash << 5) - hash + value.charCodeAt(i)) >>> 0;
    }
    return hash;
}

export function getDailyTradingTip(date = new Date()) {
    const dateKey = getDateKey(date);
    const index = hashString(dateKey) % TRADING_TIPS.length;
    const tip = TRADING_TIPS[index];

    return {
        ...tip,
        dateKey,
        dayLabel: date.toLocaleDateString('en-US', {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
            year: 'numeric',
        }),
    };
}

async function fetchTickerSnapshot(symbol) {
    const { getMarketTicker } = await import('../services/MarketService');
    const data = await getMarketTicker(symbol);
    return {
        symbol: data.symbol || symbol,
        price: parseFloat(data.lastPrice),
        changePercent: parseFloat(data.priceChangePercent),
        volume: parseFloat(data.volume),
    };
}

export async function getEnrichedDailyTradingTip(date = new Date()) {
    const tip = getDailyTradingTip(date);

    if (!tip.symbol) {
        return { ...tip, market: null };
    }

    try {
        const market = await fetchTickerSnapshot(tip.symbol);
        return { ...tip, market };
    } catch {
        return { ...tip, market: null };
    }
}

export function getTradingTipPoolSize() {
    return TRADING_TIPS.length;
}